import React from 'react'
import moment from 'moment'
import Grid from '@mui/material/Grid'
import SearchResident from '../SearchResident'
import SelectInput from '../SelectInput'
import MultilineTextInput from '../MultilineTextInput'
import ManyBuildingActionsInput from './ManyBuildingActionsInput'
import DateInput from '../DateInput'
import NumberInput from '../NumberInput'
import ImageGallerySelector from '../ImageGallerySelector'
import {BUILDING_NUDGE_TYPE_LABELS} from './AssistantConstants'
import {convertKeyLabelMapIntoSelectOptions} from '../../Utils/objectUtil'
import PropTypes from 'prop-types'

const BUILDING_NUDGE_TYPE_OPTIONS = convertKeyLabelMapIntoSelectOptions(BUILDING_NUDGE_TYPE_LABELS)

export default function LogActionForm(props) {
  const isCreatingForNudge = !!props.buildingNudgeId

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <SearchResident
          isRequired={true}
          disabled={isCreatingForNudge}
          value={props.residentId}
          onSelectResident={r => props.updateForm({residentId: r ? r.id : null})}
          error={props.invalidItems.includes('residentId')}
        />
      </Grid>
      <Grid item xs={12}>
        <ManyBuildingActionsInput
          value={props.actions}
          onChange={a => props.updateForm({actions: a})}
          error={props.invalidItems.includes('actions')}
        />
      </Grid>

      <Grid item xs={6}>
        <DateInput
          label="Date action was taken"
          onChange={date =>
            props.updateForm({
              actionTakenAt: moment(date).startOf('day').toDate(),
            })
          }
          value={props.actionTakenAt}
          isRequired={true}
        />
      </Grid>

      <Grid item lg={6} md={6} sm={6} xs={6}>
        <NumberInput
          label="Total price"
          onChange={v => props.updateForm({cost: v})}
          min={0}
          value={typeof props.cost === 'number' ? props.cost : null}
          showDollarSign={true}
        />
      </Grid>

      <Grid item xs={12}>
        <SelectInput
          onChange={val =>
            props.updateForm({
              reason: val,
            })
          }
          isRequired={true}
          label={'Reason'}
          disabled={isCreatingForNudge}
          options={BUILDING_NUDGE_TYPE_OPTIONS}
          value={props.reason}
          error={props.invalidItems.includes('reason')}
        />
      </Grid>
      <Grid item xs={12}>
        <MultilineTextInput
          label="Notes"
          placeholder=""
          rows={4}
          rowsMax={4}
          onChange={val => props.updateForm({notes: val})}
          value={props.notes}
        />
      </Grid>
      <Grid item xs={12}>
        <ImageGallerySelector
          maxPhotos={1}
          value={props.attachments || []}
          onChange={attachments => props.updateForm({attachments})}
          helperText="(Optional) Attach up to 3 photos"
        />
      </Grid>
    </Grid>
  )
}

LogActionForm.propTypes = {
  updateForm: PropTypes.func,
  invalidItems: PropTypes.array,
}
